// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"a5083f27","425":"572f7b9c","510":"710d0f7f","532":"414d80e7","633":"e0eadf9d","634":"3423dedb","922":"f9f7e809","937":"bc7ad418","972":"b7ad5744"}[chunkId] + ".chunk.js";
};